import { CSSProperties } from "react"
import images from "../../utils/images"
import styles from "./CloseButton.module.scss"

export interface CloseButtonProps {
  className?: string
  style?: CSSProperties
  onClick: () => void
  color?: string
}

const CloseButton = (props: CloseButtonProps) => {
  const filterStyle = props.color
    ? {
        filter:
          "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
      }
    : {}

  return (
    <button
      className={`${styles.button} ${props.className ?? ""}`}
      style={props.style}
      onClick={props.onClick}
    >
      <div className={images.closeDialog.class} style={filterStyle} />
    </button>
  )
}

export default CloseButton
